import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * CollapsibleSection - Animated collapsible wrapper for dashboard sections
 * 
 * Props:
 * @param {string} title - Section title
 * @param {React.ReactNode} children - Section content
 * @param {boolean} defaultOpen - Initial open state (default: true)
 * @param {boolean} isDarkMode - Theme flag
 * @param {object} colors - Theme colors object
 * @param {React.ReactNode} badge - Optional badge/count element to show next to title
 */
const CollapsibleSection = ({ title, children, defaultOpen = true, isDarkMode = false, colors = {}, badge }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div style={{ marginBottom: '0px' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          width: '100%',
          padding: '10px 0',
          border: 'none',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          textAlign: 'left',
          color: colors.text || (isDarkMode ? '#E2E8F0' : '#1E293B'),
          transition: 'opacity 0.2s ease',
        }}
      >
        <ChevronDown
          size={18}
          style={{
            color: colors.textMuted || (isDarkMode ? '#64748B' : '#94A3B8'),
            transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
            flexShrink: 0,
          }}
        />
        <span style={{
          fontSize: '13px',
          fontWeight: '600',
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          color: colors.textMuted || (isDarkMode ? '#64748B' : '#94A3B8'),
        }}>
          {title}
        </span>
        {badge}
        <div style={{
          flex: 1,
          height: '1px',
          backgroundColor: colors.border || (isDarkMode ? '#1E293B' : '#E2E8F0'),
          marginLeft: '8px',
          opacity: 0.5,
        }} />
      </button>
      <div style={{
        maxHeight: isOpen ? '5000px' : '0px',
        overflow: 'hidden',
        transition: isOpen 
          ? 'max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease' 
          : 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease',
        opacity: isOpen ? 1 : 0,
      }}>
        {children}
      </div>
    </div>
  );
};

export default CollapsibleSection;
